import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  Filter,
  TextInput,
  DateField,
  DateInput,
} from 'react-admin';
import CustomActions from '../../../components/CustomActions';
import { ListPagination } from '../../../utils';
import { PanelRowActionsMenu, PanelStatusBadge } from './components';

const PanelFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Nome" source="name" alwaysOn />
    <TextInput label="Laboratório" source="lab.name" />
    <TextInput label="Projeto" source="project.name" />
    <TextInput label="Objetivo da lista" source="statusObjective.name" />
    <DateInput label="Data da Criação" source="createdAt" />
  </Filter>
);

const PanelList = (props) => (
  <List
    hasCreate={true}
    perPage={25}
    title="Lista de Painéis"
    exporter={false}
    bulkActionButtons={false}
    actions={<CustomActions disableExport={true} />}
    filters={<PanelFilter />}
    sort={{ field: 'createdAt', order: 'DESC' }}
    pagination={<ListPagination />}
    {...props}
  >
    <Datagrid bulkActionButtons={false} rowClick='edit'>
      <PanelStatusBadge label="Status" sortable={false} />
      <TextField label="Nome da lista" source="name" />
      <TextField sortable={false} label="Laboratório" source="lab.name" />
      <TextField sortable={false} label="Projeto" source="project.name" />
      <TextField sortable={false} label="Objetivo da lista" source="statusObjective.name" />
      <NumberField sortable={false} label="Quantidade de Médicos" source="userCount" />
      <DateField label="Data da Criação" source="createdAt" />
      <PanelRowActionsMenu />
    </Datagrid>
  </List>
);
 
export default PanelList;
 
 
 
 
